<template>
  <div>
    <b-card class="p-0 m-0" header="Biometrics">
      <b-form>
        <b-form-group class="mb-2">
          <label :for="gender.name">{{ gender.placeholder }}</label>
          <b-form-select
            :id="gender.name"
            :name="gender.name"
            v-model="model.gender"
            size="sm">
            <option key="0" :value="null" disabled>Select an option</option>
            <option v-for="(option, i) in gender.options" :key="i+1" :value="option">
              {{ option }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group class="mb-2">
          <label :for="canPlaySports.name">{{ canPlaySports.placeholder }}</label>
          <b-form-radio-group
            :id="canPlaySports.name"
            :name="canPlaySports.name"
            v-model="model.canPlaySports"
            :options="canPlaySports.options">
          </b-form-radio-group>
        </b-form-group>
        <b-form-group class="mb-2">
          <label :for="height.name">{{ height.placeholder }}</label>
          <b-form-select
            :id="height.name"
            :name="height.name"
            v-model="model.height"
            size="sm">
            <option key="0" :value="null" disabled>Select an option</option>
            <option v-for="(option, i) in height.options" :key="i+1" :value="option">
              {{ option }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group class="mb-2">
          <label :for="weight.name">{{ weight.placeholder }}</label>
          <b-form-input
            :id="weight.name"
            :name="weight.name"
            v-model="model.weight"
            placeholder="Enter weight (lbs)"></b-form-input>
        </b-form-group>
        <div>
          <div v-if="!signup" class="w-100 d-flex justify-content-between pt-2">
            <b-button class="bg-danger" size="sm" @click="$emit('toggleBiometrics')">Cancel</b-button>
            <b-button class="spnod-admin__form--button" size="sm" :disabled="isDisabled" v-b-modal="modals.save._id">
              <p v-if="!isSending">Submit</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </b-button>
          </div>
          <div v-else class="w-100 d-flex justify-content-between pt-2">
            <div></div>
            <b-button class="spnod-admin__form--button" size="sm" :disabled="isDisabled" @click="handleSubmit">
              <p v-if="!isSending">Submit</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </b-button>
          </div>
        </div>
      </b-form>
    </b-card>

    <!--  Save Modal  -->
    <Modal
      :_id="modals.save._id"
      :message="modals.save.message"
      @success="handleSubmit" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import Modal from '../Notifications/Modal'

export default {
  name: 'BiometricsForm',
  components: { Modal },
  data() {
    return {
      model: {},
      isSending: false,
      isDisabled: false,
      modals: {
        save: {
          _id: 'modal-save',
          message: 'Are you sure you want to save?'
        }
      }
    }
  },
  props: ['user', 'signup'],
  computed: {
    ...mapGetters(['getMyInfo', 'biometricsSchema']),
    gender() { return this.biometricsSchema[0] || {} },
    canPlaySports() { return this.biometricsSchema[1] || {} },
    height() { return this.biometricsSchema[2] || {} },
    weight() { return this.biometricsSchema[3] || {} }
  },
  methods: {
    ...mapActions(['loadBiometrics', 'submitBiometrics']),
    handleSubmit: async function () {
      this.isSending = true
      await this.submitBiometrics(this.model)
      if (this.signup) {
        this.$router.push('/survey')
      } else {
        this.$emit('toggleBiometrics')
      }
      this.isSending = false
    }
  },
  mounted: async function() {
    if (!this.biometricsSchema.length) await this.loadBiometrics()
    if (this.user.biometrics) this.model = await cloneDeep(this.user.biometrics)
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Biometrics/BiometricsForm.vue?381c813b